export default __webpack_public_path__ + "static/media/A_arte_de_brincar_2.077e3f63.jpg";